import { Box, BoxProps, ProgressCircle } from '@chakra-ui/react';
import React from 'react';

export interface MCircularProgressProps extends Omit<
  ProgressCircle.RootProps,
  'value'
> {
  isIndeterminate?: boolean;
  value?: number;
  color?: string;
  trackColor?: string;
}

/*
 * v3 note: `CircularProgress` was replaced by the namespace-only
 * `ProgressCircle.Root/Circle/Track/Range/Label/ValueText`. `size` is the
 * recipe's named variant (`3xs`–`xl`, default `xs`); the app's extra small
 * steps live in `styles/chakra/components/ProgressCircle.ts`.
 */
const MCircularProgress = React.forwardRef<
  HTMLDivElement,
  MCircularProgressProps
>(({ isIndeterminate, value, color, trackColor, children, ...rest }, ref) => (
  <ProgressCircle.Root
    ref={ref}
    value={isIndeterminate ? null : (value ?? null)}
    {...rest}
  >
    <ProgressCircle.Circle>
      <ProgressCircle.Track stroke={trackColor} />
      <ProgressCircle.Range stroke={color} />
    </ProgressCircle.Circle>
    {children}
  </ProgressCircle.Root>
));

export const MCircularProgressLabel = React.forwardRef<
  HTMLDivElement,
  BoxProps
>(({ children, ...rest }, ref) => (
  <Box
    ref={ref}
    position="absolute"
    inset={0}
    display="flex"
    alignItems="center"
    justifyContent="center"
    fontSize="inherit"
    {...rest}
  >
    {children}
  </Box>
));

export default MCircularProgress;
